import React from "react";
import { Form } from "react-bootstrap";
import { useSelector } from "react-redux";

const NewSimForm = ({
  values,
  errors,
  touched,
  handleChange,
  handleBlur,
  setFieldValue,
  setFieldTouched,
}) => {
  const catalog_sim_products = useSelector(
    (state) => state.sims.catalog_sim_products
  );
  return (
    <>
      <Form.Group className="mb-3">
        <Form.Label>Sim Type</Form.Label>
        <Form.Select
          name="simType"
          value={values.simType}
          onChange={(e) => {
            setFieldValue("name", e.target.value);
            handleChange(e);
          }}
          onBlur={handleBlur}
          isInvalid={Boolean(touched.simType && errors.simType)}
        >
          <option value="">Select SIM Card Type</option>
          {/* <option value="IoT SIM Card">IoT Sim Card</option>
          <option value="IoT SIM Chip">IoT Sim Chip</option> */}
          {catalog_sim_products.map((product) => (
            <option key={product.id} value={product.id}>
              {product.simProduct.name}
            </option>
          ))}
        </Form.Select>
        {!!touched.simType && (
          <Form.Control.Feedback type="invalid">
            {errors.simType}
          </Form.Control.Feedback>
        )}
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>Price</Form.Label>
        <Form.Control
          type="text"
          name="price"
          value={values.price}
          onChange={handleChange}
          onBlur={handleBlur}
          isInvalid={Boolean(touched.price && errors.price)}
        />
        {!!touched.price && (
          <Form.Control.Feedback type="invalid">
            {errors.price}
          </Form.Control.Feedback>
        )}
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>VAT(%)</Form.Label>
        <Form.Control
          type="text"
          value={values.vat}
          name="vat"
          onChange={handleChange}
          onBlur={handleBlur}
          isInvalid={Boolean(touched.vat && errors.vat)}
        />
        {!!touched.vat && (
          <Form.Control.Feedback type="invalid">
            {errors.vat}
          </Form.Control.Feedback>
        )}
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>Unit Type</Form.Label>
        <Form.Select
          name="unitType"
          value={values.unitType}
          onChange={handleChange}
          onBlur={handleBlur}
          isInvalid={Boolean(touched.unitType && errors.unitType)}
        >
          <option value="">Select Unit Type</option>
          <option value="second">Piece</option>
        </Form.Select>
        {!!touched.unitType && (
          <Form.Control.Feedback type="invalid">
            {errors.unitType}
          </Form.Control.Feedback>
        )}
      </Form.Group>
    </>
  );
};

export default NewSimForm;
